<template>
  <v-app>
    <v-navigation-drawer
      app
      color="primary"
    >
    </v-navigation-drawer>
    <v-main class="derecha">
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
          >
            <v-card
              class="elevation-3"
              tile
            >
              <v-card-title>
                Login
              </v-card-title>
              <v-form
                @submit.prevent="login"
              >
              <v-card-text>
                 <v-text-field
                  v-model="form.username"
                  label="Nombre de usuario"
                  name="login"
                  append-icon="mdi-account"
                  type="text"
                />
                <v-text-field
                  v-model="form.password"
                  id="password"
                  label="Contraseña"
                  name="password"
                  append-icon="mdi-lock"
                  type="password"
                />
                <v-btn
                  name="submit"
                  type="submit"
                  outlined
                  class="my-5"
                  block
                >
                  Entrar
                </v-btn>
              </v-card-text>
                </v-form>
              <v-col
                cols="12"
                sm="8"
              >
                <router-link :to="{ name: 'RequestPasswordReset' }">
                      Olvido su contraseña?
                </router-link>
              </v-col>

            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import types from '@/types';

export default {
  data() {
    return {
      form: {
        username: '',
        password: '',
      },
    };
  },

  methods: {
    ...mapMutations({
      [types.SHOW_BUSY]: `${types.APP}/${types.SHOW_BUSY}`,
      [types.HIDE_BUSY]: `${types.APP}/${types.HIDE_BUSY}`,
      [types.SHOW_WARNING]: `${types.APP}/${types.SHOW_WARNING}`,
    }),
    ...mapActions({
      [types.LOGIN]: `${types.USER}/${types.LOGIN}`,
    }),
    login() {
      this[types.SHOW_BUSY]('Login in...');
      this[types.LOGIN](this.form)
        .then(() => {
          setTimeout(() => {
            const { next } = this.$route.query;
            if (next) {
              this.$router.push(next);
            } else {
              this.$router.push({ name: 'Dashboard' });
            }
          }, 500);
        })
        .catch((error) => {
          const statusCode = error.response.status;
          let message;
          switch (statusCode) {
            case 401:
              this[types.SHOW_WARNING]('Invalid username or password.');
              break;
            case 403:
              message = error.response.data ? error.response.data.detail : '';
              this[types.SHOW_WARNING](message);
              break;
            case 500:
              this[types.SHOW_ERROR]('Error contacting the server.');
              break;
            default:
              break;
          }
        })
        .finally(() => {
          this[types.HIDE_BUSY]();
        });
    },
  },
};
</script>

<style>
.derecha {
  background-color: rgb(156, 153, 153);
}
</style>



// WEBPACK FOOTER //
// src/views/user/Login.vue